export const FETCH_PRICING_SUCEESS = "FETCH_PRICING_START";
export const FETCH_PRICING_FAIL = "FETCH_PRICING_FAIL";
export const FETCH_MENU_SUCCESS = "FETCH_MENU_START";
export const FETCH_MENU_FAIL = "FETCH_MENU_FAIL";
